import { ParsedUrlQuery } from 'querystring';

import { useMemo, useState } from 'react';

import { useSearchParams } from 'next/navigation';
import { useTheme } from 'styled-components';

import { useDevice } from '@contexts/device';
import { Star } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Accordion from '@components/Accordion/next/Accordion';
import { paramsToObject } from '@components/views/utils';
import Typography from '@components/Typography';

import {
  CollapsableStyledClassFilter,
  StarButtonContainer,
  ClassFilterTitle,
} from './ClassFilterStyle';
export interface ClassFilterProps {
  title?: string;
  handleSearch: (star: number[]) => void;
  selectedStars?: number[];
}

const ClassFilter = ({
  title,
  handleSearch,
  selectedStars,
}: ClassFilterProps) => {
  const { palette } = useTheme();
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);

  const { isDesktop } = useDevice();
  const [selectedStar, setSelectedStar] = useState<Array<number>>(
    selectedStars ? selectedStars : []
  );

  const handleClick = (page: number) => {
    const stars = isDesktop
      ? query?.star
        ? [...selectedStar]
        : []
      : [...selectedStar];
    const index = stars.indexOf(page);
    if (stars && index !== -1) {
      stars.splice(index, 1);
    } else {
      stars.push(page);
    }
    setSelectedStar(stars);
    handleSearch(stars);
  };

  const isSelected = (index: number) => {
    return query?.star?.includes(index.toString()) ? 'selected' : '';
  };

  const isSelectedSmallScreen = (index: number) => {
    return selectedStar?.includes(index) ? 'selected' : '';
  };

  return (
    <Accordion
      label={<ClassFilterTitle>{title}</ClassFilterTitle>}
      headerContentColor='eclipse'
      alwaysShowBottomBorder={false}
      headerPadding={isDesktop ? '0px' : '15px'}
      mobileLabelFontSize='16px'
      iconSize={16}
      accordionContentBorderRadius='0px'
      labelFontSize='16px'
      iconColor='NL800'
      contentPadding='0px'
      backgroundColor='white'
      accordionTitleStyles={{
        color: palette.NL800,
      }}
      accordionWrapperStyles={{
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <CollapsableStyledClassFilter>
        <StarButtonContainer
          className={isDesktop ? isSelected(3) : isSelectedSmallScreen(3)}
          onClick={() => handleClick(3)}
        >
          <CustomIcon icon={Star} fontSize={12} />

          <Typography weight='SemiBold' color='black' variant='caption2'>
            3
          </Typography>
        </StarButtonContainer>
        <StarButtonContainer
          className={isDesktop ? isSelected(4) : isSelectedSmallScreen(4)}
          onClick={() => handleClick(4)}
        >
          <CustomIcon icon={Star} fontSize={12} /> 4
        </StarButtonContainer>
        <StarButtonContainer
          className={isDesktop ? isSelected(5) : isSelectedSmallScreen(5)}
          onClick={() => handleClick(5)}
        >
          <CustomIcon icon={Star} fontSize={12} /> 5
        </StarButtonContainer>
      </CollapsableStyledClassFilter>
    </Accordion>
  );
};

export default ClassFilter;
